export function joinKeywords(str: string[]) {
  return str?.join(' ') || ''
}

export function validateEmail(mail: string) {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail.trim())
}

export function containUrl(content: string): boolean {
  if (!content) return false
  const config = useRuntimeConfig()
  const regex = new RegExp('^https://' + escapeRegexp(config.public.baseDomain), 'g')
  const jps = matchAll(regex, content)
  const matches = matchAll(/h*ttps?:\/\//g, content)
  return matches.length - jps.length > 0
}

function matchAll(regexp: RegExp, input: string) {
  const matches = []
  let match
  if (!regexp.flags.startsWith('g')) return []
  while ((match = regexp.exec(input)) !== null) {
    matches.push(match)
  }
  return matches
}

export function abbText(str: string, len: number) {
  if (!str) return ''
  if (str.length < len) return str
  return str.substring(0, len) + '...'
}

export function hashCode(str: string): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = hash * 31 + str.charCodeAt(i)
    hash = hash | 0 //符号付き32bit整数にする。
  }
  return hash
}

export type DeviceType = 'mobile' | 'tablet' | 'desktop'

export function getDevice(): DeviceType {
  const ua = navigator.userAgent
  if (
    ua.indexOf('iPhone') > 0 ||
    ua.indexOf('iPod') > 0 ||
    (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)
  ) {
    return 'mobile'
  } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
    return 'tablet'
  } else {
    return 'desktop'
  }
}

export function split(str: string): string[] {
  const splits = []
  let semiFlag = false
  let orFlag = false
  let notFlag = false
  let substr = ''
  for (let i = 0; i < str.length; i++) {
    if (str[i] === '"') {
      if (substr.length === 1) {
        if (substr.startsWith('+')) {
          orFlag = true
          substr = ''
        } else if (substr.startsWith('-')) {
          notFlag = true
          substr = ''
        }
      }
      if (semiFlag) {
        if (orFlag) {
          splits.push('+"' + substr + '"')
        } else if (notFlag) {
          splits.push('-"' + substr + '"')
        } else {
          splits.push('"' + substr + '"')
        }
        substr = ''
        semiFlag = false
        orFlag = false
        notFlag = false
      } else {
        semiFlag = true
      }
    } else if (!semiFlag && /[\s]/.exec(str.substr(i, 1))) {
      if (substr.length > 0) {
        splits.push(substr)
        substr = ''
      }
    } else {
      substr += str[i]
    }
  }
  if (substr.length > 0) {
    splits.push(substr)
  }

  const result: string[] = []
  const tmpResult: string[] = []
  for (let i = 0; i < splits.length; i++) {
    const s = splits[i]
    if (s.length > 1 && (s.startsWith('-') || s.startsWith('+'))) {
      if (tmpResult.length > 0) {
        result.push(tmpResult.join(' '))
        tmpResult.splice(0)
      }
      result.push(s)
    } else if (s.length > 2 && s.startsWith('"') && s.endsWith('"')) {
      if (tmpResult.length > 0) {
        result.push(tmpResult.join(' '))
        tmpResult.splice(0)
      }
      result.push(s)
    } else {
      tmpResult.push(s)
    }
  }
  if (tmpResult.length > 0) {
    result.push(tmpResult.join(' '))
    tmpResult.splice(0)
  }
  return result
}
